/**
 * @description：请求配置
 */
export enum ResultEnum {
  SUCCESS = 200,
  ERROR = 500,
  OVERDUE = 401,
  TIMEOUT = 60000,
  TYPE = "success"
}

/**
 * @description：请求方法
 */
export enum RequestEnum {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  PUT = "PUT",
  DELETE = "DELETE"
}

/**
 * @description：常用的 contentTyp 类型
 */
export enum ContentTypeEnum {
  // json
  JSON = "application/json;charset=UTF-8",
  // text
  TEXT = "text/plain;charset=UTF-8",
  // form-data 一般配合qs
  FORM_URLENCODED = "application/x-www-form-urlencoded;charset=UTF-8",
  // form-data 上传
  FORM_DATA = "multipart/form-data;charset=UTF-8"
}

/**
 * @description: 校验网络请求状态码
 * @param {{}} response
 * @return void
 */
export const checkStatus = async (response, err?: AxiosError) => {
  const { status, data } = response;
  switch (status) {
    case 400:
      ElMessage.error("请求失败！请您稍后重试");
      break;
    case 401:
      if (status === 401) {
        if (!isSilenced) {
          // ② 第一次
          isSilenced = true; // ③ 立锁
          //ElMessage.error("当前账号无权限访问！");
          ElMessage.error(data.msg);
          // 跳第三方统一登录
          initLogin();
        }
        router.replace(LOGIN_URL);
        // ④ 后续统统静默失败
        return Promise.reject(err);
      }
      // return Promise.reject(err);
      break;
    case 403:
      initLogin();
      router.replace(LOGIN_URL);
      ElMessage.error("登录失效！请您重新登录");
      break;
    case 404:
      ElMessage.error("你所访问的资源不存在！");
      break;
    case 405:
      ElMessage.error("请求方式错误！请您稍后重试");
      break;
    case 408:
      ElMessage.error("请求超时！请您稍后重试");
      break;
    case 500:
      if (err?.request?.responseType === "blob") {
        const errStr = await blobToString(err?.response?.data as Blob);
        ElMessage.error(JSON.parse(errStr)?.msg as string);
        // @ts-expect-error 类型断言
      } else if (err?.response?.data?.msg) {
        // @ts-expect-error 类型断言
        ElMessage.error(err?.response?.data?.msg as string);
      } else {
        ElMessage.error("服务异常！");
      }
      break;
    case 502:
      ElMessage.error("网关错误！");
      break;
    case 503:
      ElMessage.error("服务不可用！");
      break;
    case 504:
      ElMessage.error("网关超时！");
      break;
    default:
      ElMessage.error("请求失败！");
  }
};
